import React, { useState } from "react";

import LoaderClasses from '../assets/scss/Loader.module.scss'

export interface LoaderProps {
    error?: string
    class?: string
}

function Loader(props: LoaderProps) {
    const [loading] = useState(true);

    
    
    if (loading) {
        return (
            <div className={[LoaderClasses.loader, props.class].join(" ")}>
                <svg xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 150 150" width="150" height="150"> 
                    <polygon points="150,75 112.5,140 37.5,140 0,75.5 37.5,10 112.5,10">
                    </polygon>
                </svg>
                <div>{props.error}</div>
            </div>
        )
    }

    return null
}

export default Loader;